<template>
  <div class="videoInsertInput">
    <div class="inputWrapper">
      <h3>INSERT URL OF A VIDEO</h3>
      <div class="toggleDiv" v-on:click="toggle()">
        <p>Should the video autoplay?</p>
        <img
          class="autoplayToggle"
          src="@/assets/EndOfLife/toggleEnabled.svg"
          v-if="this.autoplayOn"
        />
        <img
          class="autoplayToggle"
          src="@/assets/EndOfLife/toggleEnabled.svg"
          v-if="!this.autoplayOn"
        />
      </div>
      <input
        v-if="!showError"
        type="text"
        ref="video"
        name="videoUrl"
        id="videoUrl"
        placeholder="Insert link from Youtube or Vimeo"
        v-model="videoUrl"
      />
      <input
        v-if="showError"
        type="text"
        ref="video"
        name="videoUrl"
        id="videoUrl"
        placeholder="You haven't provided a link ⛔️"
        v-model="videoUrl"
      />
      <div class="btnWrapper">
        <button-global
          type="neutral"
          text="CANCEL"
          @eventPassed="closeVideo"
        ></button-global>
        <button-global
          type="positive"
          text="SAVE"
          @eventPassed="insertVideo"
        ></button-global>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/bus.js";
import ButtonGlobal from "./ButtonGlobal";

export default {
  components: {
    ButtonGlobal,
  },
  data() {
    return {
      videoUrl: "",
      autoplayOn: false,
      showError: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.$refs.video.focus();
    });
  },
  methods: {
    toggle: function () {
      this.autoplayOn = !this.autoplayOn;
    },
    closeVideo() {
      bus.$emit("closeVideoModal");
      this.showError = false;
    },
    insertVideo() {
      if (this.videoUrl === "") {
        this.showError = true;
      } else {
        this.showError = false;
        var videoRemadeLink;
        if (this.videoUrl.includes("youtube")) {
          let videoHash = this.videoUrl.slice(32, 55);
          videoRemadeLink =
            "https://www.youtube.com/embed/" +
            videoHash +
            (this.autoplayOn
              ? "?rel=0&amp;controls=0&amp;showinfo=0&autoplay=1&mute=1"
              : "?rel=0&amp;controls=0&amp;showinfo=0");
        } else if (this.videoUrl.includes("youtu.be")) {
          let videoHash = this.videoUrl.slice(17, 55);
          videoRemadeLink =
            "https://www.youtube.com/embed/" +
            videoHash +
            (this.autoplayOn
              ? "?rel=0&amp;controls=0&amp;showinfo=0&autoplay=1&mute=1"
              : "?rel=0&amp;controls=0&amp;showinfo=0");
        } else if (this.videoUrl.includes("vimeo")) {
          let videoHash = this.videoUrl.slice(18, 55);
          videoRemadeLink =
            "https://player.vimeo.com/video/" +
            videoHash +
            (this.autoplayOn
              ? "?title=0&byline=0&portrait=0&autoplay=1&muted=1"
              : "?title=0&byline=0&portrait=0");
        } else {
          alert("Only Yotube and Vimeo supported.");
          return;
        }
        bus.$emit("insertVideo", videoRemadeLink);
      }
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.autoplayToggle {
  width: 40px;
  margin-left: 8px;
}
.toggleDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
}
.videoInsertInput {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}
div.inputWrapper {
  height: auto;
  padding: 15px 30px;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
}
div.inputWrapper > input {
  border: 1px solid #707070;
  border-radius: 5px;
  background-color: #ffffff;
  width: 100%;
  height: 40px;
  padding: 7px 12px;
}

div.inputWrapper > p {
  font-size: 1em;
}

h3 {
  color: #707070;
  font-size: 24px;
  margin-bottom: 25px;
}
.btnWrapper {
  margin: 20px 0;
  display: flex;
  justify-content: center;
}

p {
  color: #707070;
  font-size: 1em;
  margin: 0px;
}
</style>
